import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';



import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../_services/authentication.service';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
  })
export class JwtInterceptor implements HttpInterceptor {
    token
    currentUser
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        // console.log('request', request)
        // if (typeof sessionStorage !== 'undefined' && !request.url.includes('/api/auth')) {
        //     if (!this.authenticationService.user && !this.authenticationService.token && sessionStorage.getItem('currentUser'))
        //         this.authenticationService
        //             .verify()
        //             .toPromise()
        //             .then((res) => {
        //                 this.currentUser = this.authenticationService.user;
        //             })
        //             .catch((err) => {
        //                 console.log('err', err);
        //             });
        // }
        const token: any = this.authenticationService.token;

        const currentUser: any = this.authenticationService.user;
        const isLoggedIn = currentUser && token;
        const isApiUrl = request.url.startsWith(environment.apiUrl) || request.url.startsWith(environment.phpApiUrl);
        console.log(currentUser, token, this.authenticationService.state)
        console.log('intercept jwt', token)
        console.log('this.token', this.token)
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache'
                },
                withCredentials: true
            });
        }

        return next.handle(request).pipe(
            tap((httpEvent: any | HttpEvent<any>) => { // REFRESH TOKEN
                // Skip request
                if (httpEvent.type === 0) {
                    return;
                }
                // console.log("response: ", httpEvent);

                let token: string;
                if (httpEvent instanceof HttpResponse) {
                    if (httpEvent.headers.has('token')) {
                        token = httpEvent.headers.get('token');
                        this.authenticationService.token = token;
                        sessionStorage.setItem('token', token);
                    }
                }
            }));
    }
}
